import React, { useEffect, useState } from 'react';
import { usePWA } from '../hooks/usePWA';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const DISMISS_KEY = 'schleishare-install-hint-dismissed';

const PwaManager = () => {
  const { isInstallable, installPWA, isUpdateAvailable, reloadPage } = usePWA();
  const [showInstall, setShowInstall] = useState(false);
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const onOnline = () => setOnline(true);
    const onOffline = () => setOnline(false);
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  useEffect(() => {
    if (!isInstallable) return;
    const dismissedAt = Number(localStorage.getItem(DISMISS_KEY) || 0);
    if (!dismissedAt || Date.now() - dismissedAt > 14 * 24 * 60 * 60 * 1000) {
      setShowInstall(true);
    }
  }, [isInstallable]);

  const dismissInstall = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setShowInstall(false);
  };

  return (
    <>
      {!online && (
        <div className="fixed left-1/2 top-20 z-[110] -translate-x-1/2 rounded-full bg-amber-100 px-4 py-2 text-sm font-bold text-amber-900 shadow-lg border border-amber-200">
          <SafeIcon icon={FiIcons.FiWifiOff} className="inline mr-2" /> Offline – zuletzt geladene Inhalte bleiben verfügbar
        </div>
      )}

      {isUpdateAvailable && (
        <div className="fixed bottom-4 left-4 right-4 z-[110] mx-auto flex max-w-xl items-center justify-between gap-4 rounded-2xl bg-gray-950 p-4 text-white shadow-2xl">
          <div>
            <p className="font-bold">Neue SchleiShare-Version verfügbar</p>
            <p className="text-sm text-gray-300">Aktualisieren, um die neuesten Funktionen zu verwenden.</p>
          </div>
          <button type="button" onClick={reloadPage} className="shrink-0 rounded-xl bg-emerald-500 px-4 py-2 text-sm font-bold text-white hover:bg-emerald-400">
            Aktualisieren
          </button>
        </div>
      )}

      {showInstall && !isUpdateAvailable && (
        <div className="fixed bottom-4 left-4 right-4 z-[105] mx-auto max-w-xl rounded-2xl border border-emerald-200 bg-white p-4 shadow-2xl">
          <div className="flex items-start gap-3">
            <div className="rounded-xl bg-emerald-100 p-3 text-emerald-700"><SafeIcon icon={FiIcons.FiSmartphone} /></div>
            <div className="flex-1">
              <p className="font-bold text-gray-900">SchleiShare als App nutzen</p>
              <p className="text-sm text-gray-600">Schneller öffnen, offline weitersehen und Benachrichtigungen verwalten.</p>
              <div className="mt-3 flex gap-2">
                <button type="button" onClick={async () => { await installPWA(); setShowInstall(false); }} className="rounded-xl bg-emerald-600 px-4 py-2 text-sm font-bold text-white">Installieren</button>
                <button type="button" onClick={dismissInstall} className="rounded-xl px-4 py-2 text-sm font-bold text-gray-500 hover:bg-gray-50">Später</button>
              </div>
            </div>
            <button type="button" onClick={dismissInstall} className="p-1 text-gray-400"><SafeIcon icon={FiIcons.FiX} /></button>
          </div>
        </div>
      )}
    </>
  );
};

export default PwaManager;
